import { resolve } from "../../di/di";
import { diConstants } from "../../di/di.constants";
import HttpClient from "./http-client";

export function injectHttpClient() {
  return resolve<HttpClient>(diConstants.HTTP)();
}
